/* Spanish catalog mirroring locale-reports-labels-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'rep.zeroHidden': 'Las cuentas tienen saldo cero en este periodo. Muéstrelas mediante los filtros.',
  'rep.showZero': 'Mostrar cuentas con saldo cero',
  'rep.group.tax': 'IMPUESTO SOBRE BENEFICIOS',
  'rep.trial.titleHelp': 'El balance de comprobación enumera todas las cuentas del plan de cuentas con su saldo en el periodo seleccionado. Toca una línea de cuenta para ver los justificantes contabilizados en ella.',
  'rep.trial.viewHelp': 'Por defecto, el balance de comprobación solo muestra las cuentas activas: las que tienen saldo o movimiento. "Mostrar también cuentas inactivas" añade el resto del plan de cuentas, y "Mostrar solo cuentas con movimiento" exige que la cuenta tenga asientos en el periodo. Mostrar como elige si los importes aparecen con decimales, como importes enteros o en miles.',
  'rep.trial.empty': 'No hay saldos contabilizados en el periodo seleccionado.',
  'rep.trial.oneSupplier': '1 proveedor',
  'rep.trial.supplierCount': '{n} proveedores',
  'rep.trial.oneCustomer': '1 cliente',
  'rep.trial.customerCount': '{n} clientes',
  'rep.trial.oneOpenCustomerItem': '1 partida abierta',
  'rep.trial.openCustomerItems': '{n} partidas abiertas',
  'rep.trial.customerDifference': 'Otros asientos / diferencia de conciliación',
  'rep.trial.noCustomerBalances': 'No hay saldos de clientes en la vista seleccionada.',
  'rep.trial.oneOpenSupplierItem': '1 partida abierta',
  'rep.trial.openSupplierItems': '{n} partidas abiertas',
  'rep.trial.supplierDifference': 'Otros asientos / diferencia de conciliación',
  'rep.trial.noSupplierBalances': 'No hay saldos de proveedores en la vista seleccionada.',
  'rep.trial.exportTitle': 'Balance de comprobación: {column}',
  'rep.group.assets': 'ACTIVOS',
  'rep.group.equityLiabilities': 'PATRIMONIO / PASIVOS',
  'rep.group.operatingIncome': 'INGRESOS DE EXPLOTACIÓN',
  'rep.group.operatingCosts': 'GASTOS DE EXPLOTACIÓN',
  'rep.groupTotal': 'Total {group}',
  'rep.balance.opening': 'Apertura',
  'rep.balance.movement': 'Variación',
  'rep.balance.closing': 'Cierre',
  'rep.showAs.withDecimals': 'Con decimales',
  'rep.showAs.whole': 'Importes enteros',
  'rep.showAs.thousands': 'Miles',
  'rep.result.titleHelp': 'La cuenta de resultados muestra los ingresos y gastos del periodo y lo que queda como resultado. Abre una sección para ver las cuentas detrás de las cifras y toca una línea de cuenta para ver los justificantes contabilizados en ella.',
  'rep.result.subtitle': 'Empieza por el resumen y abre el detalle de las cuentas cuando lo necesites.',
  'rep.result.income': 'Ingresos de explotación',
  'rep.result.costs': 'Gastos de explotación',
  'rep.result.finance': 'Partidas financieras',
  'rep.result.beforeTax': 'Resultado antes de impuestos',
  'rep.result.noLines': 'Todavía no hay actividad en estas cuentas.',
  'rep.total': 'Total',
  'rep.showDetails': 'Mostrar detalles',
  'rep.hideDetails': 'Ocultar detalles',
  'rep.shareOfLargest': '{pct} % de la partida mayor',
  'rep.showVouchersFor': 'Mostrar todos los justificantes de {account}',
  'rep.period.otherYear': 'Se muestran las cifras del ejercicio fiscal {year}.',
  'rep.period.singleYear': 'El periodo abarca dos ejercicios fiscales. Los informes se calculan por ejercicio fiscal con el saldo de apertura desde el inicio del año, así que elige un periodo dentro de un mismo año.',
  'rep.export.busy': 'Exportando...',
  'rep.export.downloaded': '{format} descargado',
  'rep.export.failed': 'No se pudo exportar el informe.',
  'rep.export.pdfUnavailable': 'El PDF del informe no está conectado al backend.',
  'rep.export.year': 'Año',
  'rep.export.period': 'Periodo',
  'rep.export.summary': 'Resumen',
  'rep.export.item': 'Partida',
  'rep.export.amount': 'Importe',
  'rep.accountHelp.receivables': 'Las cuentas por cobrar son el dinero que los clientes te deben por facturas que aún no se han pagado.',
  'rep.accountHelp.bank': 'Los depósitos bancarios muestran el dinero de la cuenta operativa.',
  'rep.accountHelp.payables': 'Las cuentas por pagar son las facturas y compras que debes a proveedores.',
  'rep.accountHelp.outputVat': 'El IVA repercutido es el IVA que has cobrado en las ventas.',
  'rep.accountHelp.inputVat': 'El IVA soportado es el IVA que has pagado en las compras y que normalmente puedes deducir.',
  'rep.accountHelp.vatSettlement': 'La cuenta de liquidación de IVA muestra el IVA neto que debes o que te deben.',
  'rep.accountHelp.vatableSales': 'Los ingresos por ventas sujetas a IVA muestran las ventas ordinarias en las que se cobra IVA repercutido.',
  'rep.accountHelp.group.asset': 'Cuenta de activo: valores que la empresa posee o que le deben.',
  'rep.accountHelp.group.equityLiability': 'Patrimonio o pasivo: financiación, importes adeudados y partidas de liquidación.',
  'rep.accountHelp.group.income': 'Cuenta de ingresos: ventas y otros ingresos de la empresa.',
  'rep.accountHelp.group.goods': 'Coste de mercancías: costes relacionados con mercancías, materias primas o reventa.',
  'rep.accountHelp.group.payroll': 'Gasto de nómina: salarios, pagas de vacaciones y prestaciones del personal.',
  'rep.accountHelp.group.operating': 'Gasto de explotación: los costes de gestionar la empresa.',
  'rep.accountHelp.group.finance': 'Cuenta financiera o de impuestos: intereses, partidas financieras o gasto por impuestos.',
  'rep.accountHelp.other': 'Cuenta {account} del plan de cuentas.',
  'rep.accountHelp.openVouchers': 'Toca la línea de la cuenta para ver todos los justificantes contabilizados en ella.',
  'rep.dimensions.title': 'Proyecto y departamento',
  'rep.dimensions.help': 'Filtra el informe sin cambiar los datos de origen. Se conserva el justificante completo, incluidas las líneas de contrapartida.',
  'rep.dimensions.project': 'Proyecto',
  'rep.dimensions.department': 'Departamento',
  'rep.dimensions.all': 'Todos',
  'rep.dimensions.unassigned': 'Sin asignar',
  'rep.incompleteBasisTitle': 'La base contable es incompleta',
  'rep.incompleteBasisText': 'El informe no se presenta como completo porque no se ha documentado la cobertura del diario ni los datos de apertura necesarios. Las pruebas disponibles se conservan para su revisión.',
  'rep.importedBasisTitle': 'Estadísticas contables importadas.',
  'rep.importedBasisText': 'Estas cifras proceden de estadísticas de cuentas importadas y validadas, no de asientos del diario en Plumme. No están certificadas y no se pueden usar para presentaciones, certificación de pagos ni cierre del ejercicio.',
  'rep.importedBasisExport': 'Estadísticas de cuentas importadas y validadas; no completas según el diario ni certificadas.'
});
